import * as React from "react";

interface ErrorBannerProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorBanner({
  message,
  onRetry,
}: ErrorBannerProps): React.JSX.Element {
  return (
    <div
      role="alert"
      data-testid="error-banner"
      className="flex items-start gap-3 rounded-[var(--radius)] border border-[var(--danger)] bg-[color-mix(in_srgb,var(--danger)_8%,transparent)] px-4 py-3"
    >
      <svg
        className="w-5 h-5 text-[var(--danger)] flex-shrink-0 mt-0.5"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <div className="flex-1">
        <p className="text-[var(--danger)] text-[14px] font-[500]">{message}</p>
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="flex-shrink-0 text-[var(--danger)] text-[13px] font-[600] underline hover:no-underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--danger)] rounded px-2 py-1 min-h-[44px] min-w-[44px]"
        >
          Повторить
        </button>
      )}
    </div>
  );
}
